import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

// Новий дизайн (?v2): поки людина сама не перемкнула тему, вона як у системі — світла чи темна в налаштуваннях телефона або браузера.
// Старий дизайн, як і раніше, світлий, доки не обрано темну
function initialNightMode() {
    const saved = JSON.parse(localStorage.getItem('nightmode'));
    if (saved !== null || !document.documentElement.classList.contains('bp-v2')) return saved;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 1 : 0;
}

export default new Vuex.Store({
  state: {
    cart: JSON.parse(localStorage.getItem('cart')) || [],
    currentProduct: {},
    categories: [],
    products: [],
    pizzas: [],
    beverages: [],
    freeBeverages: [],
    streets: [],
    cities: [],
    locationCities: [],
    takeawayLocations: [],
    deliveryTimes: [],
    nightMode: initialNightMode(),

    locationCityId: JSON.parse(localStorage.getItem('locationCityId')),
    phone: '',
    address: '',
    // Стан закриття з /api/{місто}/settings: all — не приймаємо нічого, delivery — лише доставку
    closed: { all: false, delivery: false, title: '', text: '' },
    // phone: '066 711 92 91',
    // address: 'м. Луцьк, вул. Липинського, 7',
  },
  getters: {
    // Скільки одиниць у кошику (сума кількостей позицій)
    cartCount(state) {
      return state.cart.reduce((count, product) => count + (parseInt(product.quanity) || 0), 0);
    },

    // Сума кошика до знижок: ціна позиції вже з додатками (рядок «Сума» в кошику)
    cartTotal(state) {
      return state.cart.reduce((total, product) => total + product.price * product.quanity, 0);
    }
  },
  mutations: {
    addToCart(state, product) {
      state.cart.push(product);
      state.cart = state.cart.sort((a, b) => {
        return a.priceWithoutAdditionals - b.priceWithoutAdditionals
      });
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    removeFromCart(state, product) {
      let arr = state.cart.filter(obj => {
        return obj != product;
      });

      state.cart = arr;
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    emptyCart(state) {
      state.cart = [];
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    setCurrentProduct(state, product) {
      state.currentProduct = product;
    },
    
    setMode(state, mode) {
      state.nightMode = mode;
    },

    setLocationCityId(state, locationCityId) {
      state.locationCityId = locationCityId;
    },

    setPhone(state, phone) {
      state.phone = phone;
    },

    setAddress(state, address) {
      state.address = address;
    },

    setClosed(state, closed) {
      state.closed = closed;
    }
  },
  actions: {
    getCategories({ state }) {
      return new Promise((resolve, reject) => {
        if(state.categories.length) {
          resolve(state.categories);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/categories`).then(response => {
          state.categories = response.data.categories;
          resolve(state.categories);
        }).catch(e => reject(e));
      });
    },

    getProducts({ state }) {
      return new Promise((resolve, reject) => {
        if(state.products.length) {
          resolve(state.products);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/products`).then(response => {
          state.products = response.data.products;
          resolve(state.products);
        }).catch(e => reject(e));
      });
    },

    getPizzas({ state }) {
      return new Promise((resolve, reject) => {
        if(state.pizzas.length) {
          resolve(state.pizzas);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/pizzas`).then(response => {
          state.pizzas = response.data;
          resolve(state.pizzas);
        }).catch(e => reject(e));
      });
    },

    getBeverages({ state }) {
      return new Promise((resolve, reject) => {
        if(state.beverages.length) {
          resolve(state.beverages);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/beverages`).then(response => {
          state.beverages = response.data;
          resolve(state.beverages);
        }).catch(e => reject(e));
      });
    },

    getFreeBeverages({ state }) {
      return new Promise((resolve, reject) => {
        if(state.freeBeverages.length) {
          resolve(state.freeBeverages);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/free-beverages`).then(response => {
          response.data.forEach(e => {
            e.freeBeverage = 1;
            e.additionaIngredients = [];
            e.priceWithoutAdditionals = e.price;
            e.quanity = 1;
            e.size = e.volume + ' ml';
          });

          state.freeBeverages = response.data;
          resolve(state.freeBeverages);
        }).catch(e => reject(e));
      });
    },

    getStreets({ state }) {
      return new Promise((resolve, reject) => {
        if(state.streets.length) {
          resolve(state.streets);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/streets`).then(response => {
          state.streets = response.data;
          resolve(state.streets);
        }).catch(e => reject(e));
      });
    },

    getCities({ state }) {
      return new Promise((resolve, reject) => {
        if(state.cities.length) {
          resolve(state.cities);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/cities`).then(response => {
          state.cities = response.data;
          resolve(state.cities);
        }).catch(e => reject(e));
      });
    },

    getLocationCities({ state }) {
      return new Promise((resolve, reject) => {
        if(state.locationCities.length) {
          resolve(state.locationCities);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/location_cities?is_enabled_only=1`).then(response => {
          state.locationCities = response.data;
          resolve(state.locationCities);
        }).catch(e => reject(e));
      });
    },

    getTakeawayLocations({ state }) {
      return new Promise((resolve, reject) => {
        if(state.takeawayLocations.length) {
          resolve(state.takeawayLocations);
          return;
        }
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/location_cities/takeaways`).then(response => {
          state.takeawayLocations = response.data;
          resolve(state.takeawayLocations);
        }).catch(e => reject(e));
      });
    },

    getDeliveryTimes({ state }) {
      return new Promise((resolve, reject) => {
        axios.get(`${Vue.prototype.SERVER_URL}/api/${state.locationCityId}/order/delivery-time`).then(response => {
          state.deliveryTimes = response.data;
          resolve(state.deliveryTimes);
        }).catch(e => reject(e));
      });
    }
  }
})
